export default {
  ADD_BROKER_INFORMATION (state, information) {
    if (Array.isArray(information)) {
      state.documents = information
    } else {
      state.brokerInformation = information
    }
  },
  ADD_NEW_BROKER_INFORMATION (state, doc) {
    state.documents.push(doc)
  },
  DELETE_BROKER_INFORMATION (state, id) {
    state.documents = state.documents.filter(d => d.id !== id)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/brokerInformation.js